import { useState } from 'react';
import type { FormEvent } from 'react';
import { Alert, BrandLockup, BrandMark, Button, Icon, TextField } from '@onepos/ui';
import { useAuth } from '../lib/auth';

export function LoginPage({ message }: { message?: string }) {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | undefined>(message);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      setError('Email va parolni kiriting.');
      return;
    }
    setBusy(true);
    setError(undefined);
    try {
      await signIn(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      setBusy(false);
    }
  };

  return (
    <div className="cn-login">
      <section className="cn-login__brand" aria-hidden="true">
        <BrandMark size={520} tone="white" simple={false} className="cn-login__water" />
        <BrandLockup height={52} tone="white" title="ONE POS" />
        <div>
          <p className="cn-login__lead">Restoranlarni bitta joydan boshqaring.</p>
          <ul className="cn-login__points">
            <li>
              <Icon name="store" /> Restoranni bir necha daqiqada to‘liq sozlangan holda oching
            </li>
            <li>
              <Icon name="shield" /> Har bir o‘zgarish jurnalda: kim, qachon, nima uchun
            </li>
            <li>
              <Icon name="device" /> Qurilmalar, tariflar va yordam rejimi — bir joyda
            </li>
          </ul>
        </div>
        <span className="cn-login__foot">onepos.uz</span>
      </section>

      <section className="cn-login__form-wrap">
        <form className="cn-login__form" onSubmit={(e) => void submit(e)} noValidate>
          <div>
            <h1 className="cn-login__title">Platforma paneliga kirish</h1>
            <p className="cn-muted">Faqat ONE POS jamoasi uchun.</p>
          </div>
          {error && <Alert tone="danger">{error}</Alert>}
          <TextField
            label="Email"
            type="email"
            autoComplete="username"
            inputMode="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
          />
          <div className="cn-pw">
            <TextField
              label="Parol"
              type={show ? 'text' : 'password'}
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="cn-pw__toggle"
              aria-label={show ? 'Parolni yashirish' : 'Parolni ko‘rsatish'}
              aria-pressed={show}
              onClick={() => setShow((v) => !v)}
            >
              <Icon name="eye" />
            </button>
          </div>
          <Button type="submit" variant="primary" disabled={busy}>
            {busy ? 'Tekshirilmoqda…' : 'Kirish'}
          </Button>
        </form>
      </section>
    </div>
  );
}

export function NotAdminPage({ email }: { email: string | null }) {
  const { signOut } = useAuth();
  return (
    <div className="cn-center">
      <div className="op-card cn-narrow">
        <div className="op-card__body" style={{ paddingTop: 24 }}>
          <h1 className="cn-login__title">Ruxsat yo‘q</h1>
          <p className="cn-muted">
            <strong>{email ?? 'Bu hisob'}</strong> platforma admini emas. Restoran egasi bo‘lsangiz,
            app.onepos.uz manzilidan telefon raqamingiz bilan kiring.
          </p>
          <Button variant="secondary" onClick={() => void signOut()}>
            <Icon name="logout" /> Boshqa hisob bilan kirish
          </Button>
        </div>
      </div>
    </div>
  );
}
